import Vue from "vue";
import Vuex from "vuex";

import user from "./modules/user";
import simulator from "./modules/simulator";
import simulations from "./modules/simulations";

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		user,
		simulator,
		simulations,
	},

	actions: {},

	getters: {},
});
